require('../styles/modules/board.scss');

import React, { Component, PropTypes } from 'react'
import Goal from './Goal'
import Robot from './Robot'
import BoardCanvas from './BoardCanvas'

class Board extends Component {
  constructor(props) {
    super(props);
    this.state = { size: 20 }
  }
  componentDidMount(){
    this.props.fetchOldChallenge()
  }

  getRobotProps(color) {
    const { selectRobot, status, moveRobot } = this.props
    return {
      selectRobot: selectRobot,
      currentColor: status.currentColor,
      moveRobot: moveRobot,
      key: color,
      size: this.state.size
    }
  }

  renderRobots() {
    const { robot, status } = this.props
    let robots = [];
    for(var color in robot){
      robots.push(<Robot {...robot[color]} { ...this.getRobotProps(color) }/> )
    }
    return robots
  }

  render() {
    const { size } = this.state
    const { board, goals } = this.props
    return (
      <div>
        <div className = 'board' >
          <BoardCanvas boardProps = { board } isMobile = { this.state.size === 20 } />
          { this.renderRobots() }
          <Goal size = { size } { ...goals }/>
        </div>
      </div>
    )
  }
}

Board.propTypes = {
}

export default Board



// WEBPACK FOOTER //
// ./components/HighscoreBoard.js